
import { handleResponse, requestOptions } from '@/auth';
import * as CONFIG from '@/config/config'

export const userService = {
    getAll,
    getById,
    DeleteUser,
    AddUser,
};

function getAll() {
    return fetch(CONFIG.CORE_URL + `/users`, requestOptions.get())
        .then(handleResponse);
}


function getById(id) {
    return fetch(CONFIG.CORE_URL + `/users/${id}`, requestOptions.get())
        .then(handleResponse);
}

function DeleteUser(id) {
    return fetch(CONFIG.CORE_URL + `/users/DeleteUser/${id}`, requestOptions.get())
        .then(handleResponse);
}

function AddUser(username, password, firstname, lastname, role) {
    return fetch(CONFIG.CORE_URL + `/users/AddUser/post`, requestOptions.post({username, password, firstname, lastname, role}))
    .then(handleResponse);
}

